import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import configurationService from '../api/configurationService';

// Fetch the Singleton Config
export const useConfiguration = () => {
    return useQuery({
        queryKey: ['platformConfig'],
        queryFn: () => configurationService.get().then((res) => res.data),
        staleTime: 5 * 60 * 1000
    });
};

// Update Global Numbers (Fees, Commissions)
export const useUpdateConfiguration = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => configurationService.update(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['platformConfig'] });
        }
    });
};

// Manage Cities
export const useManageCities = () => {
    const queryClient = useQueryClient();

    const addCity = useMutation({
        mutationFn: (payload) => configurationService.addCity(payload),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['platformConfig'] })
    });

    const deleteCity = useMutation({
        mutationFn: (cityId) => configurationService.deleteCity(cityId),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['platformConfig'] })
    });

    return { addCity, deleteCity };
};

// hooks/useConfiguration.ts

export const useManageStates = () => {
    const queryClient = useQueryClient();

    const addState = useMutation({
        mutationFn: (payload) => configurationService.addState(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['platformConfig'] });
        }
    });

    const deleteState = useMutation({
        mutationFn: (stateId) => configurationService.deleteState(stateId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['platformConfig'] });
        }
    });

    return { addState, deleteState };
};
